






















































































































































import Vue from "vue";
import Component from "vue-class-component";
import { PolicyDto } from "@/api/ClientPortalApiClient";
import { Prop } from "vue-property-decorator";
import router, { ROUTES } from "@/router";
import { FormatDate } from "@/filters/FormatDate";

@Component
export default class PolicyCardProtection extends Vue {
  @Prop(PolicyDto) readonly policyDetails: PolicyDto | undefined;

  openPolicyDetails() {
    if (this.policyDetails) {
      router.push({
        name: ROUTES.policyDetailsProtection,
        params: { policyId: this.policyDetails.id.toString() }
      });
    }
  }

  get policyEndDateString(): string {
    if (this.policyDetails) {
      return new Date(this.policyDetails.maturityDate) <= new Date("01/01/1900")
        ? "Open Ended"
        : FormatDate.format(this.policyDetails.maturityDate);
    }

    return "";
  }
}
